import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://heritagefamilypa.com";
const BRAND = "Heritage Family Protection Agency";

const META = {
  "/": {
    title: `Life Insurance & Family Protection in Atlanta, GA | ${BRAND}`,
    description:
      "Looking for life insurance near you? Heritage Family Protection Agency in Atlanta, GA offers free quotes on life insurance, final expense, mortgage protection, healthcare, legal plans, retirement & tax services. Call (470) 814-0464.",
  },
  "/services": {
    title: `Our Services — Life, Healthcare, Legal, Retirement & Tax | ${BRAND}`,
    description:
      "Explore every family protection service under one shield: life insurance, KonnectMD virtual healthcare, mortgage protection, LegalShield legal plans, retirement planning, and tax services.",
  },
  "/life-insurance": {
    title: `Life Insurance Quotes — Term, Whole, IUL & Final Expense | ${BRAND}`,
    description:
      "Get a free life insurance quote in about a minute. Term, whole life, universal, IUL, final expense and children's policies from A-rated carriers — matched to your family and budget.",
  },
  "/taxes": {
    title: `Tax Preparation & Filing Services | ${BRAND}`,
    description:
      "File your taxes with Heritage Family Protection Agency — individual and small business returns, maximized credits and deductions, amendments, and year-round tax planning.",
  },
  "/legalshield": {
    title: `LegalShield Plans — Affordable Legal & Identity Protection | ${BRAND}`,
    description:
      "LegalShield memberships from $14.95/month: legal advice, will preparation, document review, and IDShield identity protection for families and small businesses.",
  },
  "/konnectmd": {
    title: `KonnectMD — 24/7 Virtual Healthcare, No Insurance Needed | ${BRAND}`,
    description:
      "Talk to a doctor 24/7, get 1,000+ common medications free, and pay $0 copays. KonnectMD virtual healthcare memberships from $59.99/month cover your partner and kids under 26.",
  },
  "/vivint": {
    title: `Vivint Smart Home Security — Cameras, Monitoring & Smart Locks | ${BRAND}`,
    description:
      "Protect your home with Vivint smart home security through Heritage Family Protection Agency — doorbell and outdoor cameras, smart locks, 24/7 professional monitoring. Get a free custom quote.",
  },
  "/community": {
    title: `Community Event Bulletin — Let's Talk & Give Back | ${BRAND}`,
    description:
      "See where Heritage Family Protection Agency shows up in the community. Join us at Let's Talk & Give Back on September 26, 2026 at Stone Terrace, Stonecrest GA — clothing, connections & community.",
  },
  "/careers/tax-pro": {
    title: `Tax Professional Careers — Apply Today | ${BRAND}`,
    description:
      "Become a Tax Professional with Heritage Family Protection Agency. Full training, professional software, and mentorship — help families keep more of what they earn. Apply now.",
  },
  "/will-and-trust": {
    title: `Will & Trust Planning — Estate Planning with Life Insurance | ${BRAND}`,
    description:
      "Will and trust planning that works hand in hand with life insurance. Protect your wishes, avoid probate, and make sure your legacy is funded from day one. Free planning call.",
  },
  "/healthcare": {
    title: `Healthcare Solutions — KonnectMD Virtual Care & MightyWell Health | ${BRAND}`,
    description:
      "Every healthcare program Heritage offers: KonnectMD 24/7 virtual care memberships with free prescriptions and $0 copays, plus MightyWell Health Copay, HSA & Concierge bundles with major medical protection.",
  },
  "/about": {
    title: `About Us — A Family Protecting Families | ${BRAND}`,
    description:
      "Heritage Family Protection Agency is a husband-and-wife led agency built on education, integrity, and trust — helping families prepare before life's unexpected moments.",
  },
  "/meet-the-owner": {
    title: `Meet Eric Grainger — Agency Owner | ${BRAND}`,
    description:
      "Meet Eric Grainger, founder of Heritage Family Protection Agency — a husband, father of eight, and advocate for family financial protection and legacy planning.",
  },
  "/meet-the-team": {
    title: `Meet the Team | ${BRAND}`,
    description:
      "Meet the licensed professionals behind Heritage Family Protection Agency, including Eric and Markayla Grainger — a growing family serving families.",
  },
  "/partners": {
    title: `Our Partners — LegalShield & KonnectMD | ${BRAND}`,
    description:
      "Heritage Family Protection Agency partners with LegalShield for affordable legal & identity protection and KonnectMD for 24/7 virtual healthcare — plus A-rated life insurance carriers nationwide.",
  },
  "/careers": {
    title: `Careers — Agent, LegalShield Associate & KonnectMD Ambassador | ${BRAND}`,
    description:
      "Build a career protecting families. Join Heritage as a licensed financial services agent, an independent LegalShield Associate, or a KonnectMD Ambassador.",
  },
  "/book-a-call": {
    title: `Book a Call — Free Protection Review | ${BRAND}`,
    description:
      "Schedule a free, no-pressure call with Heritage Family Protection Agency. Pick a time that works and get answers about life insurance, healthcare, and legal protection.",
  },
  "/blog": {
    title: `Family Protection Blog — Life Insurance, Healthcare & Legacy Guides | ${BRAND}`,
    description:
      "Plain-English guides on life insurance, final expense, mortgage protection, virtual healthcare, legal plans, and legacy planning from Heritage Family Protection Agency.",
  },
  "/contact": {
    title: `Contact Us — Free Quotes & Family Protection Help | ${BRAND}`,
    description:
      "Reach Heritage Family Protection Agency: call (470) 814-0464, email info@heritagefamilypa.com, or send a message online. Free quotes and consultations for every family.",
  },
};

export const Seo = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/blog/")) return;
    const meta = META[pathname] || META["/"];
    document.title = meta.title;

    let desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", meta.description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${SITE}${pathname === "/" ? "/" : pathname}`);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", meta.title);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute("content", meta.description);
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", `${SITE}${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);

  return null;
};
